import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BaseService } from './base.service';

/** 与后端 GameLevelStatus 一致 */
export enum GameLevelStatus {
  INACTIVE = 0,
  ACTIVE = 1,
}

export interface GameLevelItem {
  id: number;
  levelCode: string;
  name: string;
  cardImage: string;
  baseScore: number;
  questionCount: number;
  secondPerQuestion: number;
  timeBonus: number;
  victoryBonus: number;
  /** 每日次数上限（与后端 dailyLimit 一致；旧数据可能缺省） */
  dailyLimit?: number;
  ruleDescription: string | null;
  status: GameLevelStatus | number;
  resourceCount: number;
  createdAt: string;
  createdBy: number | null;
}

export type GameLevelSavePayload = {
  levelCode?: string;
  name?: string;
  cardImage?: string;
  baseScore?: number;
  questionCount?: number;
  secondPerQuestion?: number;
  timeBonus?: number;
  victoryBonus?: number;
  dailyLimit?: number;
  ruleDescription?: string | null;
  status?: GameLevelStatus | number;
};

@Injectable({
  providedIn: 'root',
})
export class GameLevelService extends BaseService {
  constructor(protected override http: HttpClient, protected override router: Router) {
    super(http, router);
  }

  list(status?: number | null): Promise<GameLevelItem[]> {
    const q = status === 0 || status === 1 ? { status } : undefined;
    return this.get('/game/levels', q);
  }

  create(body: GameLevelSavePayload): Promise<GameLevelItem> {
    return this.post('/game/levels', body);
  }

  update(id: number, body: GameLevelSavePayload): Promise<GameLevelItem> {
    return this.post(`/game/levels/${id}`, body);
  }

  deleteLevel(id: number): Promise<void> {
    return super.remove(`/game/levels/${id}`);
  }
}
